export default "__VITE_ASSET__BRc_gKkO__"